import { DomainError } from '../errors/domain-error';
import { ProductStatus, PurchaseStatus } from '../enums';

export function assertPublishedProduct(product: unknown): asserts product is NonNullable<typeof product> {
  if (!product) {
    throw new DomainError('Product not found');
  }
}

export function buildStubPurchase(params: {
  userId: string;
  productId: string;
}): {
  userId: string;
  productId: string;
  status: PurchaseStatus;
  stripePaymentId: string;
} {
  return {
    userId: params.userId,
    productId: params.productId,
    status: PurchaseStatus.COMPLETED,
    stripePaymentId: `stub_${Date.now()}`,
  };
}

export function defaultProductStatus(requested?: ProductStatus): ProductStatus {
  return requested ?? ProductStatus.DRAFT;
}
